import type { RefObject } from 'react';
import type SmoothScroll from 'smooth-scroll';
import type { Options as LibSmoothScrollOptions } from 'smooth-scroll';

export interface SmoothScrollOptions extends LibSmoothScrollOptions {
  align?: 'top' | 'middle' | 'bottom';
  port?: 'top' | 'bottom';
  speedAsDuration?: boolean;
}

export function scroll(
  this: SmoothScroll,
  node: HTMLElement,
  options?: SmoothScrollOptions
) {
  const {
    align = 'top',
    port = 'top',
    offset: initialOffset = 0,
    ...rest
  } = {
    speedAsDuration: true,
    clip: true,
    speed: 800,
    updateURL: false,
    ...options,
  };

  return this.animateScroll(node, undefined, {
    ...rest,
    offset: (anchor, toggle) => {
      const elementRect = node.getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;

      let offset;
      switch (align) {
        case 'middle':
          offset = Math.round(elementRect.bottom / 2);
          break;
        case 'bottom':
          offset = elementRect.bottom;
          break;
        case 'top':
        default:
          offset = 0;
          break;
      }

      return (
        (port === 'top' ? offset : offset - clientHeight) -
        (typeof initialOffset === 'function'
          ? initialOffset(anchor, toggle)
          : initialOffset)
      );
    },
  });
}

export const scrollToElement = <T extends HTMLElement, K extends HTMLElement>(
  ref: RefObject<K>,
  refContainer?: RefObject<T>
) => {
  if (ref.current == null) return;

  if (refContainer?.current == null) {
    window.scrollTo({ behavior: 'smooth', top: ref.current.offsetTop });
    return;
  }

  refContainer.current.scrollTo({
    behavior: 'smooth',
    top: ref.current.offsetTop,
  });
};
